var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0.75H9C8.66858 0.750331 8.35083 0.882133 8.11648 1.11648C7.88213 1.35083 7.75033 1.66858 7.75 2V8.25H1.5C1.16858 8.25033 0.850831 8.38213 0.616482 8.61648C0.382133 8.85083 0.250331 9.16858 0.25 9.5V18.25H17.75V2C17.7496 1.6686 17.6178 1.35087 17.3835 1.11654C17.1491 0.882199 16.8314 0.75038 16.5 0.75ZM4.625 17V12.625H7.125V17H4.625ZM16.5 17H8.375V12C8.375 11.8342 8.30915 11.6753 8.19194 11.5581C8.07473 11.4408 7.91576 11.375 7.75 11.375H4C3.83424 11.375 3.67527 11.4408 3.55806 11.5581C3.44085 11.6753 3.375 11.8342 3.375 12V17H1.5V9.5H9V2H16.5V17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.5H10.25V5.75H11.5V4.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 4.5H14V5.75H15.25V4.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.25H10.25V9.5H11.5V8.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 8.25H14V9.5H15.25V8.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 11.9998H10.25V13.2498H11.5V11.9998Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 11.9998H14V13.2498H15.25V11.9998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.e1107f50660685e0d6f8535243f550eb.svg";
export { ForwardRef as ReactComponent };